<script setup>
  import { ref, onMounted, watch, getCurrentInstance } from 'vue';
  import { useRouter } from 'vue-router';
  import { storeToRefs } from 'pinia';
  import { useUserStore } from '../../../../stores/user';
  import { usePageLoadingStore } from '../../../../../../stores/pageLoading';
  import MyPageCorpJobFairCorpInfoView from '../MyPageCorpJobFairCorpInfoView.vue';
  import mypageJobFairService from '../../../../services/mypage/jobFair/mypageJobFairService';

  const router = useRouter();
  const loadingStore = usePageLoadingStore()

  const userStore = useUserStore();
  const { user, isAuthenticated } = storeToRefs(userStore);

  const globals = getCurrentInstance().appContext.config.globalProperties;
  const { alert } = globals;

  const userCorpMasterYn = ref('N'); // 기업마스터유무
  const userCorpId = ref(''); // 기업아이디

  // 기업정보 관리 상세
  const corpDetail = ref({});
  const corpYn = ref('Y');

  // 정보제공 동의 여부
  const retrieveRecruitPrivacyAgreeYnByCorpId = () => {
    userCorpId.value = user.value.userInfo.corporation.corpId;

    mypageJobFairService.retrieveRecruitPrivacyAgreeYnByCorpId(userCorpId.value)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          corpYn.value = result;
        }
      })
      .catch( (error) =>  {
        loadingStore.loading = false;
      });
  }

  // 조회
  const retrieveCorporationDetail = () => {
    userCorpMasterYn.value = user.value.userInfo.corpMasterYn;
    userCorpId.value = user.value.userInfo.corporation.corpId;

    loadingStore.loading = true;
    mypageJobFairService.retrieveCorporation(userCorpId.value)
      .then( (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          corpDetail.value.setCorpInfo(result);
          // 사업자등록번호
          if(result.bizNum ) {
            const bizNum = result.bizNum;
            if(bizNum) {
              result.bizNum = bizNum.substring(0,3) + '-' + bizNum.substring(3,5) + '-' + bizNum.substring(5);
            }
          }

          // 사업장소재지
          if(result.residenceArea1 && result.residenceArea2) {
            residenceAreaRef.value?.initSelectedOption(result.residenceArea1, result.residenceArea2)
          }

          // 창립연월
          if(result.foundYm ) {
            const foundYm = result.foundYm;
            if(foundYm) {
              result.foundYm = foundYm.substring(0,4) + '.' + foundYm.substring(4,6);
            }
          }
        }
      })
      .catch((error) => {
        loadingStore.loading = false;
      });
  }

  const onClickUpdate = () => {
    router.push({ name: 'MyPageCorpInfoUpdate', query: { corpId: userCorpId.value } });
  }

  onMounted(() => {
    retrieveCorporationDetail();
    retrieveRecruitPrivacyAgreeYnByCorpId();
  });
</script> 

<template>
  <div v-if="corpYn === 'Y'">
    <MyPageCorpJobFairCorpInfoView ref="corpDetail" />
    <div class="btn-wrap text-right mb-xs">
      <KSASecondaryButton class="gray_button" text="수정" @click="onClickUpdate" />
    </div>
  </div>
  <div v-else class="resume-wrap" style="display: flex; align-items: center; justify-content: center;">
    등록된 기업정보가 없습니다.
  </div>
</template>

<style lang="scss" scoped>
@import "../../../../../../assets/scss/theme";

</style>
